import { fetchApi } from 'api/fetchApi'
import { paths as notifications_emails } from 'api/generated/notifications_emails'

export const fetchEmailNotificationsApi = () =>
  fetchApi<
    notifications_emails['/notifications/email_notifications']['get']['responses']['200']['schema']
  >('/notifications/email_notifications')
